module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_ccpa", [["div",{"class":"site-page privacy"},[["section",{"class":"static-page-wrapper"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title editor-wrapper","data-fox-alias":"ccpaTitle","data-fox-context":"privacy"},[["p",{},[["textNode",{"text":"Privacy Notice for California residents"}]]]]]]]]],["section",{"class":"static-page-content"},[["div",{"class":"page-width static-page-docs"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/ccpa.tpl
// module id = 1081
// module chunks = 4